export default {"src":"/_next/static/media/Friday.b8bf4bd5.svg","height":1214,"width":1300};